<template>
  <v-card class="card-shadow border-radius-xl">
    <div class="px-4 py-4">
      <full-calendar
        :options="calendarOptions"
        ref="fullCalendar"
      ></full-calendar>
    </div>
  </v-card>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        contentHeight: "auto",
        initialView: "dayGridMonth",
        selectable: true,
        initialDate: new Date(),
        editable: true,
        locale: 'de',
        headerToolbar: {
          start: "title", // will normally be on the left. if RTL, will be on the right
          center: "",
          end: "today prev,next", // will normally be on the right. if RTL, will be on the left
        },
        events: []
      },
    };
  },
  watch:{
    events(){
      if(this.events && this.events.length > 0)
      this.setCalendarEvents()
    }
  },
  mounted() {
    // this.$store.dispatch("getEventsAdmin");
    if(this.events && this.events.length > 0){
      this.setCalendarEvents()
    }
  },
  computed: {
    events() {
      return this.$store.getters.events;
    },
  },
  methods: {
    setCalendarEvents(){
      // Rebuild events array from scratch to prevent duplicates
      if(this.events){
        this.calendarOptions.events = this.events.map(element => ({
          title: element.title,
          start: element.date,
          end: element.date,
          className: "bg-gradient-info",
        }));
      } else {
        this.calendarOptions.events = [];
      }
    }
  }
};
</script>
